class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce(event => {
      this.onSubmitHandler(event);
    }, 800);
    this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    facetWrapper && facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = event => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      searchParams !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach(element => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");
    document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner")
      .forEach(spinner => spinner.classList.remove("hidden"));
    document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading");
    countContainer && countContainer.classList.add("loading");
    countContainerDesktop && countContainerDesktop.classList.add("loading");

    sections.forEach(section => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    updateURLHash && FacetFiltersForm.updateURLHash(searchParams);

    // Initialize the Intersection Observer with a delay to ensure DOM updates are complete
    setTimeout(() => {
      FacetFiltersForm.initializeIntersectionObserver();
    }, 500); // Delay initialization (adjust delay as needed)
  }

  // New method to initialize the Intersection Observer
  static initializeIntersectionObserver() {
    const inViewport = (entries, observer) => {
      entries.forEach(entry => {
        if (window.DSDViewportMutationGovernance && window.DSDViewportMutationGovernance.applyInViewport) {
          window.DSDViewportMutationGovernance.applyInViewport(entry.target, entry.isIntersecting, "facets.js:viewport-observer");
        } else {
          entry.target.classList.toggle("is-inViewport", entry.isIntersecting);
        }
      });
    };

    const Obs = new IntersectionObserver(inViewport);
    const obsOptions = {}; // Adjust options if needed

    // Attach observer to every [data-inviewport] element:
    const ELs_inViewport = document.querySelectorAll('[data-inviewport]');
    ELs_inViewport.forEach(EL => {
      Obs.observe(EL, obsOptions);
    });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url).then(response => response.text()).then(responseText => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      typeof initializeScrollAnimationTrigger == "function" && initializeScrollAnimationTrigger(html.innerHTML);
    });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    typeof initializeScrollAnimationTrigger == "function" && initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer").innerHTML;
    document.getElementById("ProductGridContainer").querySelectorAll(".scroll-trigger").forEach(element => {
      element.classList.add("scroll-trigger--cancel");
    });
    // Delay Areviews initialization until the browser is idle or after the next paint. Running
    // the Areviews widget immediately after updating the product grid can cause DOM churn
    // during critical rendering. Use requestIdleCallback when available to defer work.
    if (document.querySelectorAll('.areviews_product_item').length > 0 && typeof show_infiniti_areviews === "function") {
      if (typeof window.requestIdleCallback === 'function') {
        requestIdleCallback(() => show_infiniti_areviews());
      } else {
        requestAnimationFrame(() => show_infiniti_areviews());
      }
    }

  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    containerDesktop && (containerDesktop.innerHTML = count, containerDesktop.classList.remove("loading"));
    document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner")
      .forEach(spinner => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter");
    const facetDetailsElementsFromDom = document.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter");
    Array.from(facetDetailsElementsFromDom).forEach(currentElement => {
      Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id) || currentElement.remove();
    });

    const matchesId = element => {
      const jsFilter = event ? event.target.closest(".js-filter") : void 0;
      return jsFilter ? element.id === jsFilter.id : !1;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(element => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      if (document.getElementById(elementToRender.id))
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }
        elementToRender.parentElement && document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;
      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter"));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));
        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains("mobile-facets__details") ? ".mobile-facets__close-button" : ".facets__summary";
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        const isTextInput = event.target.getAttribute("type") === "text";
        newElementToActivate && !isTextInput && newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    [".active-facets-mobile", ".active-facets-desktop"].forEach(selector => {
      const activeFacetsElement = html.querySelector(selector);
      activeFacetsElement && (document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML);
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach(selector => {
      html.querySelector(selector) && (document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML);
    });
    document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");
    sourceSummary && targetSummary && (targetSummary.outerHTML = sourceSummary.outerHTML);
    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");
    sourceHeaderElement && targetHeaderElement && (targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML);
    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");
    sourceWrapElement && targetWrapElement && (target.querySelector("show-more-button .label-show-more.hidden") &&
      sourceWrapElement.querySelectorAll(".facets__item.hidden").forEach(hiddenItem => hiddenItem.classList.replace("hidden", "show-more-item")),
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML);
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");
    sourceFacetsList && targetFacetsList && (targetFacetsList.outerHTML = sourceFacetsList.outerHTML);
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?" + searchParams}`);
  }

  static getSections() {
    return [{ section: document.getElementById("product-grid").dataset.id }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll("facet-filters-form form");
    if (event.srcElement.className === "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(event.target.closest("form"));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest("form").id === "FacetFiltersFormMobile";
      sortFilterForms.forEach(form => {
        isMobile ? form.id === "FacetFiltersFormMobile" && forms.push(this.createSearchParams(form)) :
          (form.id === "FacetSortForm" || form.id === "FacetFiltersForm" || form.id === "FacetSortDrawerForm") && forms.push(this.createSearchParams(form));
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf("?") === -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();


